// import React from 'react';
// import './Dashboard.css';
// import { Pencil, RefreshCcw, Eye, Trash } from 'lucide-react';
// import {
//   LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend
// } from 'recharts';

// const lineData = [
//   { date: '13 Mar 2025', line1: 5, line2: 7 },
//   { date: '13 Mar 2025', line1: 11, line2: 10 },
//   { date: '13 Mar 2025', line1: 6, line2: 8 },
//   { date: '13 Mar 2025', line1: 8, line2: 6 },
//   { date: '13 Mar 2025', line1: 10, line2: 9 },
//   { date: '13 Mar 2025', line1: 15, line2: 20 },
//   { date: '13 Mar 2025', line1: 9, line2: 18 },
// ];

// const pieData = [
//   { name: 'Shortlisted Candidates', value: 27, color: '#f79009' },
//   { name: 'Rejected Candidates', value: 27, color: '#0ba5ec' },
//   { name: 'Inactive Candidates', value: 27, color: '#7a5af8' },
//   { name: 'Blocked Candidates', value: 27, color: '#12b76a' },
// ];

// const tableData = Array(8).fill({
//   company: 'NewZenAlpha',
//   createdOn: '14-05-2025 15:02',
//   jobsPosted: 15,
// });

// export default function Dashboard() {
//   return (
//     <div className="dashboard">
//       <div className="card">
//         <div className="card-header">
//           <div>
//             <div className="card-title">Sessions</div>
//             <div className="card-value">66</div>
//           </div>
//           <Pencil className="icon" />
//           <div className="card-meta">Total Companies: 66</div>
//           <div className="card-meta">Interviews Completed: 66</div>
//           <div className="card-meta">Candidates Hired: 66</div>
//         </div>
//         <ResponsiveContainer width="100%" height={200}>
//           <LineChart data={lineData}>
//             <XAxis dataKey="date" />
//             <YAxis />
//             <Tooltip />
//             <Line type="monotone" dataKey="line1" stroke="#f97316" strokeWidth={2} />
//             <Line type="monotone" dataKey="line2" stroke="#3b82f6" strokeWidth={2} />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       <div className="card">
//         <div className="card-title center">Candidates (20394)</div>
//         <ResponsiveContainer width="100%" height={250}>
//           <PieChart>
//             <Pie
//               data={pieData}
//               dataKey="value"
//               nameKey="name"
//               cx="50%"
//               cy="50%"
//               innerRadius={50}
//               outerRadius={80}
//               paddingAngle={5}
//             >
//               {pieData.map((entry, index) => (
//                 <Cell key={`cell-${index}`} fill={entry.color} />
//               ))}
//             </Pie>
//             <Legend layout="vertical" verticalAlign="middle" align="right" />
//           </PieChart>
//         </ResponsiveContainer>
//       </div>

//       <div className="card">
//         <div className="table-controls">
//           <select>
//             <option>All Companies</option>
//           </select>
//           <button className="view-all-btn">View All</button>
//         </div>
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>Company</th>
//               <th>Created On</th>
//               <th>Jobs Posted</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {tableData.map((row, index) => (
//               <tr key={index}>
//                 <td>{row.company}</td>
//                 <td>{row.createdOn}</td>
//                 <td>{row.jobsPosted}</td>
//                 <td className="action-icons">
//                   <RefreshCcw className="icon blue" />
//                   <Eye className="icon gray" />
//                   <Trash className="icon red" />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }


import React from 'react';
import { Pencil, RefreshCcw, Eye, Trash } from 'lucide-react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

const lineData = [
  { date: '13 Mar 2025', line1: 5, line2: 7 },
  { date: '13 Mar 2025', line1: 11, line2: 10 },
  { date: '13 Mar 2025', line1: 6, line2: 8 },
  { date: '13 Mar 2025', line1: 8, line2: 6 },
  { date: '13 Mar 2025', line1: 10, line2: 9 },
  { date: '13 Mar 2025', line1: 15, line2: 20 },
  { date: '13 Mar 2025', line1: 9, line2: 18 },
];

const pieData = [
  { name: 'Shortlisted Candidates', value: 27, color: '#f79009' },
  { name: 'Rejected Candidates', value: 27, color: '#0ba5ec' },
  { name: 'Inactive Candidates', value: 27, color: '#7a5af8' },
  { name: 'Blocked Candidates', value: 27, color: '#12b76a' },
];

const tableData = Array(8).fill({
  company: 'NewZenAlpha',
  createdOn: '14-05-2025 15:02',
  jobsPosted: 15,
});



export default function Dashboard() {
  return (
    <div className="p-5 space-y-5">
      <Card className="border-2 border-primary">
        <CardContent className="p-5">
          <div className="flex justify-between items-center mb-2.5 flex-wrap w-full">
            <div className="relative bg-muted rounded-lg p-2.5 w-[100px] h-[60px] flex flex-col justify-between">
              <Text className="text-xs text-muted-foreground">Sessions</Text>
              <Text className="font-bold text-base">66</Text>
              <Pencil className="absolute top-2 right-2 w-3.5 h-3.5 text-muted-foreground cursor-pointer" />
            </div>
            <div className="text-sm text-center">
              <Text className="block font-semibold text-base">Total Companies</Text>
              <Text className="block font-bold text-base">66</Text>
            </div>
            <div className="text-sm text-center">
              <Text className="block font-semibold text-base">Interviews Completed</Text>
              <Text className="block font-bold text-base">66</Text>
            </div>
            <div className="text-sm text-center">
              <Text className="block font-semibold text-base">Candidates Hired</Text>
              <Text className="block font-bold text-base">66</Text>
            </div>
          </div>

          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={lineData}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="line1" stroke="#f97316" strokeWidth={2} />
              <Line type="monotone" dataKey="line2" stroke="#3b82f6" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="border-2 border-primary">
        <CardContent className="p-5">
          <Heading level="h3" className="font-bold text-center text-base mb-2.5">
            Candidates (20394)
          </Heading>
          <ResponsiveContainer width="100%" height={350}>
            <PieChart>
              <Pie
                data={pieData}
                dataKey="value"
                nameKey="name"
                cx="40%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={5}
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Legend layout="vertical" verticalAlign="middle" align="right" />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="border-2 border-primary">
        <CardHeader>
          <div className="flex justify-between mb-2.5 w-full">
            <Select defaultValue="all-companies">
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="All Companies" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all-companies">All Companies</SelectItem>
              </SelectContent>
            </Select>
            <Button variant="default" size="sm">View All</Button>
          </div>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-center font-semibold">Company</TableHead>
                <TableHead className="text-center font-semibold">Created On</TableHead>
                <TableHead className="text-center font-semibold">Jobs Posted</TableHead>
                <TableHead className="text-center font-semibold">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index} className="hover:bg-muted/50">
                  <TableCell className="text-center">{row.company}</TableCell>
                  <TableCell className="text-center">{row.createdOn}</TableCell>
                  <TableCell className="text-center">{row.jobsPosted}</TableCell>
                  <TableCell>
                    <div className="flex gap-2.5 justify-center">
                      <RefreshCcw className="w-4 h-4 text-primary cursor-pointer" />
                      <Eye className="w-4 h-4 text-muted-foreground cursor-pointer" />
                      <Trash className="w-4 h-4 text-destructive cursor-pointer" />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
